@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.override {
  gap: @space-8;
}

.override-text {
  font-weight: 500;
}

.shopper-override-part {
  background-color: var(--grey-300);
  border-radius: 4px;
  padding: @space-8;
}
